import client from '../client';
import { exportFile } from '../requestDownloadFile';

export default {
  exportCommissionBrandReports: data => {
    return exportFile('publisher/commission/reports/brand/export', data.qs, data.fileName);
  },
  exportCommissionPerformanceReports: data => {
    return exportFile('publisher/commission/reports/performance/export', data.qs, data.fileName);
  },
  exportCommissionProductReports: data => {
    return exportFile('publisher/commission/reports/product/export', data.qs, data.fileName);
  },
  exportCommissionTrackingIdReports: data => {
    return exportFile('publisher/commission/reports/tracking-id/export', data.qs, data.fileName);
  },
  // /api/artemisads/v1/publisher/commission/reports/tracking-id/export
  getPublisherCommissionReportsAgg: data => {
    return client.get(`publisher/commission/reports/agg`, { params: data }).then(res => res.data);
  },


  getPublisherCommissionReportsPerformance: data => {
    return client.get(`publisher/commission/reports/performance`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsPerformanceDailyMetric: data => {
    return client.get(`publisher/commission/reports/performance/daily-metric`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsBrand: data => {
    return client.get(`publisher/commission/reports/brand`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsBrandDailyMetric: data => {
    return client.get(`publisher/commission/reports/brand/daily-metric`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsBrandMetric: data => {
    return client.get(`publisher/commission/reports/brand/metric`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsProduct: data => {
    return client.get(`publisher/commission/reports/product`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsProductDailyMetric: data => {
    return client.get(`publisher/commission/reports/product/daily-metric`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsProductMetric: data => {
    return client.get(`publisher/commission/reports/product/metric`, { params: data }).then(res => res.data);
  },
  getPublisherBrandSearch: data => {
    return client.get(`publisher/brands/search`, { params: data }).then(res => res.data);
  },
  getPublisherProductSearch: data => {
    return client.get(`publisher/product/searchAsin`, { params: data }).then(res => res.data);
  },
  getPublisherBrandSearch: data => {
    return client.get(`publisher/brand/find/list`, { params: data }).then(res => res.data);
  },
  getPublisherProductSearch: data => {
    return client.get(`publisher/product/searchAsin`, { params: data }).then(res => res.data);
  },
  // 获取列表
  getTrackingIds: data => {
    return client.get('publisher/tracking-ids', {params:data}).then(res => res.data);
  },
  // 添加追踪ID
  addTrackingId: data => {
    return client.post('publisher/tracking-ids', data).then(res => res.data);
  },
  // 删除追踪ID
  deleteTrackingId: id => {
    return client.delete(`publisher/tracking-ids/${id}`).then(res => res.data);
  },
  // 获取子追踪ID
  getSubTrackingIds: primaryId => {
    return client.get(`publisher/tracking-ids/${primaryId}/sub-ids`).then(res => res.data);
  },
  // getReportsTrackingId
  getReportsTrackingId: primaryId => {
    return client.get(`publisher/commission/reports/tracking-id`, {params:primaryId}).then(res => res.data);
  },
  getPublisherCommissionTrackingIdMetric: data => {
    return client.get(`publisher/commission/reports/tracking-id/metric`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsTrackingIdDailyMetric: data => {
    return client.get(`publisher/commission/reports/tracking-id/daily-metric`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsTrackingIdAgg: data => {
    return client.get(`publisher/commission/reports/tracking-id/agg`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsTrackingIdDetail: data => {
    return client.get(`publisher/commission/reports/tracking-id/detail`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsTrackingId: data => {
    return client.get(`publisher/commission/reports/tracking-id`, { params: data }).then(res => res.data);
  },
  //新增接口 publisher brand Associate
  getPublisherCommissionReportsAggAssociate: data => {
    return client.get(`publisher/associate/commission/reports/agg`, { params: data }).then(res => res.data);
  },
  //table
  getPublisherCommissionReportsBrandAssociate: data => {
    return client.get(`publisher/associate/commission/reports/brand`, { params: data }).then(res => res.data);
  },
  //echart daily-metric
  getPublisherCommissionReportsBrandDailyMetricAssociate: data => {
    return client.get(`publisher/associate/commission/reports/brand/daily-metric`, { params: data }).then(res => res.data);
  },
  //echart daily
  getPublisherCommissionReportsBrandMetricAssociate: data => {
    return client.get(`publisher/associate/commission/reports/brand/metric`, { params: data }).then(res => res.data);
  },
  //导出
  exportCommissionBrandReportsAssociate: data => {
    return exportFile('publisher/associate/commission/reports/brand/export', data.qs, data.fileName);
  },
  //新增接口 publisher Product Associate
  //table
  getPublisherCommissionReportsProductAssociate: data => {
    return client.get(`publisher/associate/commission/reports/product`, { params: data }).then(res => res.data);
  },
  //echart daily-metric
  getPublisherCommissionReportsProductDailyMetricAssociate: data => {
    return client.get(`publisher/associate/commission/reports/product/daily-metric`, { params: data }).then(res => res.data);
  },
  //echart daily
  getPublisherCommissionReportsProductMetricAssociate: data => {
    return client.get(`publisher/associate/commission/reports/product/metric`, { params: data }).then(res => res.data);
  },
  //导出
  exportCommissionProductReportsAssociate: data => {
    return exportFile('publisher/associate/commission/reports/product/export', data.qs, data.fileName);
  },
  //新增接口 publisher Performance Associate
  
  //table
  getPublisherCommissionReportsPerformanceAssociate: data => {
    return client.get(`publisher/associate/commission/reports/performance`, { params: data }).then(res => res.data);
  },
  //echart daily-metric
  getPublisherCommissionReportsPerformanceDailyMetricAssociate: data => {
    return client.get(`publisher/associate/commission/reports/performance/daily-metric`, { params: data }).then(res => res.data);
  },
  //导出
  exportCommissionPerformanceReportsAssociate: data => {
    return exportFile('publisher/associate/commission/reports/performance/export', data.qs, data.fileName);
  },

  // publisher performance Creator Connections
  getPublisherCommissionReportsAggCc: data => {
    return client.get(`publisher/cc/bonus/reports/agg`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsPerformanceCc: data => {
    return client.get(`publisher/cc/bonus/reports/performance`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsPerformanceDailyMetricCc: data => {
    return client.get(`publisher/cc/bonus/reports/performance/daily-metric`, { params: data }).then(res => res.data);
  },
  exportCommissionPerformanceReportsCc: data => {
    return exportFile('publisher/cc/bonus/reports/performance/export', data.qs, data.fileName);
  },

  // publisher product Creator Connections
  getPublisherCommissionReportsProductCc: data => {
    return client.get(`publisher/cc/bonus/reports/product`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsProductMetricCc: data => {
    return client.get(`publisher/cc/bonus/reports/product/metric`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsProductDailyMetricCc: data => {
    return client.get(`publisher/cc/bonus/reports/product/daily-metric`, { params: data }).then(res => res.data);
  },
  exportCommissionProductReportsCc: data => {
    return exportFile('publisher/cc/bonus/reports/product/export', data.qs, data.fileName);
  },

  // publisher brand Creator Connections
  getPublisherCommissionReportsBrandCc: data => {
    return client.get(`publisher/cc/bonus/reports/brand`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsBrandMetricCc: data => {
    return client.get(`publisher/cc/bonus/reports/brand/metric`, { params: data }).then(res => res.data);
  },
  getPublisherCommissionReportsBrandDailyMetricCc: data => {
    return client.get(`publisher/cc/bonus/reports/brand/daily-metric`, { params: data }).then(res => res.data);
  },
  exportCommissionBrandReportsCc: data => {
    return exportFile('publisher/cc/bonus/reports/brand/export', data.qs, data.fileName);
  },
}
